import {IDateRange, LoadingConfig} from "./interfaces";
import {TemplateLoadingType} from "utils/enums";
import {addToDate, ChronoUnitLegacy, truncateDate} from 'utils/time-utils';

export const getTemplateLoadingRange = (config: LoadingConfig, referenceTime?: string): IDateRange => {
    if (config.loadingType === TemplateLoadingType.EVERYTHING) {
        return {
            'start': new Date(),
            'end': new Date()
        }
    }

    let nowTime = referenceTime ? new Date(referenceTime) : new Date();
    
    let truncateStartUnit = config.loadingConfig?.truncateStartUnit || ChronoUnitLegacy.DAYS; // or use periodUnit?? // TODO handle possible error
    let periodUnit = config.loadingConfig?.periodUnit ?? ChronoUnitLegacy.DAYS;
    let offsetUnit = config.loadingConfig?.offsetUnit ?? periodUnit;

    let period = config.loadingConfig?.period ?? 1; // truncate period (1,2,7,etc...) // TODO handle possible error
    let offset = config.loadingConfig?.offset ?? 0;

    let nowTruncated = truncateDate(nowTime, truncateStartUnit);

    let from = addToDate(nowTruncated, offset, offsetUnit)
    let to = addToDate(from, period, periodUnit);

    // Ensure that range sequence is logical
    let startRange = from > to ? to : from;
    let endRange = from > to ? from : to;


    return {
        'start': startRange,
        'end': endRange
    }
}

